import { useRouteError } from "react-router";

const RootErrorBoundary: React.FC = () => {
  const error = useRouteError();

  return (
    <>
      <p>Root Error Boundary Placeholder</p>
      <p>
        With the error boundaries in the React tree, you should never see this
        message unless there is an error with react-router&apos;s data
        lifecycle.
      </p>
      <p>{JSON.stringify(error, null, 2)}</p>
    </>
  );
};

export default RootErrorBoundary;
